import client from './client';

export const getNotifications = async () => {
    const response = await client.get('/notifications');
    return response.data;
};

export const getUnreadCount = async () => {
    const response = await client.get('/notifications/unread_count');
    return response.data;
};

export const markNotificationRead = async (notificationId) => {
    const response = await client.post(`/notifications/${notificationId}/read`);
    return response.data;
};

export const markAllNotificationsRead = async () => {
    const response = await client.post('/notifications/read_all');
    return response.data;
};

export const deleteNotification = async (notificationId) => {
    const response = await client.delete(`/notifications/${notificationId}`);
    return response.data;
};

export const clearNotifications = async () => {
    const response = await client.delete('/notifications');
    return response.data;
};

/**
 * Tell any mounted NotificationBell to refresh its unread count.
 * Dispatched after actions that read or remove notifications.
 */
export const notifyNotificationsUpdated = () => {
    window.dispatchEvent(new CustomEvent('notificationsUpdated'));
};
